import React, { useState, useEffect } from "react";

// import "babel-polyfill";
import { Link } from "@reach/router";
import useGame from "../../hooks/useGame";
import { navigate } from "@reach/router";
import styled from "styled-components";
import {
  TopicsContainer,
  LevelListContainer,
  GameSelectionContainer
} from "../../styled_components/containers";
import {
  Button,
  GreenButton,
  GreyedButton
} from "../../../../globals/components/button";
import Checkbox from "../../../../globals/components/Checkbox";
import { Loading } from "../../../../globals/components/loading";
import useTopics from "../../hooks/useTopics";
import Spelling from "../../applications/Spelling/Learn.js";
import Phonics from "../../applications/Phonics/Learn.js";
import Multiplication from "../../applications/MultiplyDivide/Learn.js";
import Addition from "../../applications/Addition/Learn.js";

import RatingStats from "../../hooks/useRatingStats";
import ReactTooltip from 'react-tooltip';
import { debug } from "util";
import { Scale } from 'react-scaling';

export default function Learn({ id, ...props }) {
  const game = useGame(id);
  console.log(game);
  const { topics } = useTopics({ game_type: game.game_type }, game);
  const [selectedLevel, setSelectedLevel] = useState([]);
  const [selectedLevelID, setSelectedLevelID] = useState(1);
  const [gameStatus, setGameStatus] = useState(props.startImmediately || false);
  const [selectedTopics, setSelectedTopics] = useState(props.topics || []);
  const [selectAll, setSelectAll] = useState(false);
  const [timeLimit,setTimeLimit] = useState(-1);
  const [questionLimit,setQuestionLimit] = useState(-1);

  var ratings = RatingStats();
  const [myRating, setMyRating] = useState(1);

  const [upperlower, setUpperLower] = useState("");

//THIS FILE IS WHERE THE LEARN TIMES TABLES STUFF WILL GO
//NEED TO LIMIT IT TO 1-12 times tables
//then have an option of lower/upper

  useEffect(() => {
    if (ratings !== undefined) {
      setMyRating(GetRating(id));
    }
  }, [ratings]);

  function GetRating(id) {
    var myrate = -1;
    for (let i = 0; i < ratings.length; i++) {
      if (ratings[i].service_id == id) {
        myrate = ratings[i].rating;
        //convert myrate to level number between 1-10

        myrate = Math.round(myrate / 150);

        if (myrate > 10)
          myrate = 10;
      }
    }
    console.log(myrate);
    return myrate;
  }

  const levels = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  if(props.timelimit > 0 && timeLimit < 0)
  {
    setTimeLimit(props.timelimit);
    setQuestionLimit(-1);
  }

  if(props.minimum > 0  && questionLimit < 0) 
  {
    setTimeLimit(-1);
    setQuestionLimit(props.minimum);
  }

  function onLevelSelect(id) {
    const topicsSelected = topics[id];

    console.log(topicsSelected);
    if (topicsSelected == undefined){
      onLevelSelect(1);
    }else{
      //sort alphabetically
      topicsSelected.sort((a, b) => a.topicname.toLowerCase().localeCompare(b.topicname.toLowerCase(),'en', {numeric: true}))
      setSelectedLevelID(id);
      setSelectedLevel(topicsSelected);
      console.log(topics);
      console.log(topicsSelected);
      console.log(id);
    }
  }

  function onTopicsSelect(id) {
    var newarray = [];
    newarray.push(id)
    setSelectedTopics(newarray);
    console.log(selectedTopics);
    //unselect any others that are selected
  }

  function onTopicsUnselect(id) {
    setSelectedTopics(
      selectedTopics.filter(function (value) {
        return value !== id;
      })
    );
    setSelectAll(false);
  }

  function onHalfSelect(id){
    if (id == "upper"){
      setUpperLower("upper");
    }else{
      setUpperLower("lower");
    }
  }

  function launchGame() {
    setGameStatus(true);
  }

  function endGame() {
    console.log("endgame");
    setGameStatus(false);
    props.onEnd && props.onEnd();
  }

  useEffect(() => {
    if (selectAll) {
      let topicIds = [];
      selectedLevel.map(topic => {
        topicIds.push(topic.id);
      });
      setSelectedTopics(
        [...selectedTopics, topicIds].reduce((acc, val) => acc.concat(val), [])
      );
    } else {
      var result = 0;
      selectedLevel.forEach(function (item) {
        if (selectedTopics.includes(item.id)) {
          result++;
        }
      });
      if (result === selectedLevel.length) {
        setSelectedTopics(
          selectedTopics.filter(function (element) {
            return (
              selectedLevel
                .reduce((acc, topic) => {
                  return [...acc, topic.id];
                }, [])
                .indexOf(element) === -1
            );
          })
        );
      } else {
      }
    }
  }, [selectAll]);

  useEffect(() => {
    if (selectedLevel != undefined) {
      var result = 0;
      selectedLevel.forEach(function (item) {
        if (selectedTopics.includes(item.id)) {
          result++;
        }
      });
      if (result === selectedLevel.length) {
        setSelectAll(true);
      } else {
        setSelectAll(false);
      }
    }
  }, [selectedLevel]);

  // once topics have loaded, default to the first level
  useEffect(() => {
      if (topics !== undefined && myRating != undefined) {
        console.log("rating = " + myRating);
        if (myRating >= 10){
          onLevelSelect(1);
        }else{
          onLevelSelect(myRating-1);
        }
      }
  }, [topics]);

  function DisablePhonics(lv){
    console.log("Level: " + lv);
    if (game.service_key != "phonics"){
      return false;
    }else{
      if (lv == 3 || lv == 4){
        console.log("LOCK THIS OFF " + lv);
        return true;
      } else{
        return false;
      }
    }
  }

  const gameComponent = () => {
    console.log(game.service_key);
    switch (game.service_key) {
      case "spelling":
        return (
          <Spelling
            homework_id={props.homework_id}
            onBack={() => endGame()}
            gameType={game.game_type}
            topics={selectedTopics}
            gameBackground={game.practice_background}
            level={selectedLevelID}
            gameData={game}
            customlist={props.customlist}
            timelimit={timeLimit}
            minimum={questionLimit}
          />
        );
        case "phonics":
          return (
            <Phonics
              homework_id={props.homework_id}
              onBack={() => endGame()}
              gameType={game.game_type}
              topics={selectedTopics}
              gameBackground={game.practice_background}
              level={selectedLevelID}
              gameData={game}
              customlist={props.customlist}
              timelimit={timeLimit}
              minimum={questionLimit}
            />
          );
      case "timetables":
        return (
          <Multiplication
            type ={props.type}
            homework_id={props.homework_id}
            onBack={() => endGame()}
            gameType={game.game_type}
            topics={selectedTopics}
            gameBackground={game.practice_background}
            level={selectedLevelID}
            gameData={game}
            customlist={props.customlist}
            timelimit={timeLimit}
            minimum={questionLimit}
          />
        );
      default:
        return null;
    }
  }


  const gameComponentMult = () => {
    console.log(game.service_key);
    console.log("MULT");
    
    let type = props.type;
    console.log(type)
    if (type == undefined){
      type = "learn|"+upperlower;
    }
    console.log(type);
        return (
          <Multiplication
            type ={type}
            homework_id={props.homework_id}
            onBack={() => endGame()}
            gameType={game.game_type}
            topics={selectedTopics}
            gameBackground={game.practice_background}
            level={selectedLevelID}
            gameData={game}
            customlist={props.customlist}
            timelimit={timeLimit}
            minimum={questionLimit}
          />
        );
  }

  const gameComponentAddition = () => {
    console.log(game.service_key);
    console.log("addition");
    
    let type = props.type;
    console.log(type)

    console.log(type);
        return (
          <Addition
            alltopics={topics}
            type ={type}
            homework_id={props.homework_id}
            onBack={() => endGame()}
            gameType={game.game_type}
            topics={selectedTopics}
            gameBackground={game.practice_background}
            level={selectedLevelID}
            gameData={game}
            customlist={props.customlist}
            timelimit={timeLimit}
            minimum={questionLimit}
          />
        );
  }

  console.log(game);
  console.log("SERVICE KEY", game.service_key);
  if (game.service_key != "timetables" && game.service_key != "addition"){
  return (
    <>
      {gameStatus && topics ? (
        gameComponent()
      ) : (
        
          <TopicsContainer lv={selectedLevel}>
            {selectedLevel != undefined ? (

              <Scale scaleTo={1920}>
                <div>
                  <GameSelectionContainer>
                    <h1>Select Topic to Learn</h1>
                    {selectedLevel.length > 0 &&
                      selectedLevel.map(topic => {
                        return (
                          <Checkbox
                            label={topic.topicname}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(topic.id);
                              } else {
                                onTopicsUnselect(topic.id);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === topic.id) !== -1
                                ? true
                                : false
                            }
                          />
                        );
                      })}
                      {selectedLevel.length == 0 &&
                      <h2>Downloading Topics... (Refresh if not downloaded after 2 minutes)</h2>}
                  </GameSelectionContainer>
                  <div>
                    {selectedTopics.length > 0 ? (
                      <GreenButton
                        style={{ width: "20%" }}
                        onClick={() => launchGame()}
                      >
                        Play
                                </GreenButton>
                    ) : (
                        <GreyedButton data-tip="You need to add a topic to practice" style={{ width: "20%" }}>Play</GreyedButton>
                      )}
                    <LevelListContainer style={{ marginBottom: "50px" }}>
                      {topics !== undefined &&
                        (levels &&
                          levels.map(level => {
                            if (DisablePhonics(level) == true){
                              return (
                                <LevelButton
                                data-tip="too high or havent unlocked" style={{ marginTop: "5px", background: "grey", border: "2px solid #a0a0a0" }}
                              >
                                <div>
                                  <h4>Level {level} (Unavailable)</h4>
                                </div>
                              </LevelButton>
                              );
                            }
                            else if (myRating == 10 && DisablePhonics(level) == false) {
                              return (
                                <LevelButton
                                  style={{ marginTop: "5px" }}
                                  onClick={() => onLevelSelect(level)}
                                  active={level === selectedLevelID}
                                >
                                  <div>
                                    <h4>Level {level}</h4>
                                  </div>
                                </LevelButton>
                              );
                            }
                            else if (myRating > 1) { 
                              if ((myRating == level || (myRating - 1) == level || level == 1) && DisablePhonics(level) == false) {
                                return (
                                  <LevelButton
                                    style={{ marginTop: "5px" }}
                                    onClick={() => onLevelSelect(level)}
                                    active={level === selectedLevelID}
                                  >
                                    <div>
                                      <h4>Level {level}</h4>
                                    </div>
                                  </LevelButton>
                                );
                              }
                              else {
                                //console.log("gray out button " + level);

                                return (
                                  <LevelButton
                                    data-tip="too high or havent unlocked" style={{ marginTop: "5px", background: "grey", border: "2px solid #a0a0a0" }}
                                  >
                                    <div>
                                      <h4>Level {level}</h4>
                                    </div>
                                  </LevelButton>
                                );
                              }
                            }
                            else {
                              if (level == 1 || (myRating == level && DisablePhonics(level) == false)) {
                                return (
                                  <LevelButton
                                    style={{ marginTop: "5px" }}
                                    onClick={() => onLevelSelect(level)}
                                    active={level === selectedLevelID}
                                  >
                                    <div>
                                      <h4>Level {level}</h4>
                                    </div>
                                  </LevelButton>
                                );
                              }
                              else {
                                //console.log("gray out button " + level);

                                return (
                                  <LevelButton
                                    data-tip="too high or havent unlocked" style={{ marginTop: "5px", background: "grey", border: "2px solid #a0a0a0" }}
                                  >
                                    <div>
                                      <h4>Level {level}</h4>
                                    </div>
                                  </LevelButton>
                                );
                              }

                            }
                          }))}
                      <Tools className='extra' />
                    </LevelListContainer>
                  </div>
                </div>
              </Scale>
            ) : (
                <div>
                </div>
              )}
              
              <Buttonz onClick={() =>{navigate(".")}}>Back</Buttonz>
          </TopicsContainer>
        )}
    </>
  );}else if (game.service_key == "timetables"){
    return (
      <> {gameStatus && topics ? (
        gameComponentMult()
      ) : (
        
          <TopicsContainer lv={selectedLevel}>
            {selectedLevel != undefined ? (

              <Scale scaleTo={1920}>
                <div>
                  <GameSelectionContainer>
                    <h1>Select Topic to Learn</h1>
                          <Checkbox
                            label={"1 times table"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(30);
                              } else {
                                onTopicsUnselect(30);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 30) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"2 times table"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(31);
                              } else {
                                onTopicsUnselect(31);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 31) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"3 times table"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(32);
                              } else {
                                onTopicsUnselect(32);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 32) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"4 times table"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(33);
                              } else {
                                onTopicsUnselect(33);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 33) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"5 times table"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(34);
                              } else {
                                onTopicsUnselect(34);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 34) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"6 times table"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(35);
                              } else {
                                onTopicsUnselect(35);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 35) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"7 times table"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(36);
                              } else {
                                onTopicsUnselect(36);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 36) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"8 times table"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(37);
                              } else {
                                onTopicsUnselect(37);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 37) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"9 times table"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(38);
                              } else {
                                onTopicsUnselect(38);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 38) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"10 times table"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(39);
                              } else {
                                onTopicsUnselect(39);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 39) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"11 times table"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(40);
                              } else {
                                onTopicsUnselect(40);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 40) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"12 times table"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(41);
                              } else {
                                onTopicsUnselect(41);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 41) !== -1
                                ? true
                                : false
                            }
                          />
                          <br/><br/>
                          <Checkbox
                            id = "lower"
                            label={"Lower"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onHalfSelect("lower");
                              } else {
                                onHalfSelect("upper");
                              }
                            }}
                            checked ={upperlower == "lower" ? true : false}
                          />
                          <Checkbox
                            id = "upper"
                            label={"Upper"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onHalfSelect("upper");
                              } else {
                                onHalfSelect("lower");
                              }
                            }}
                            checked ={upperlower == "upper" ? true : false}
                          />
                  </GameSelectionContainer>
                  <div>
                    {selectedTopics.length > 0 ? (
                      <GreenButton
                        style={{ width: "20%" }}
                        onClick={() => launchGame()}
                      >
                        Play
                                </GreenButton>
                    ) : (
                        <GreyedButton data-tip="You need to add a topic to practice" style={{ width: "20%" }}>Play</GreyedButton>
                      )}

                  </div>

                </div>
              </Scale>
            ) : (
                <div>
                </div>
              )}
              
              <Buttonz onClick={() =>{navigate(".")}}>Back</Buttonz>
          </TopicsContainer>
        )}
    </>
    )
  }
  else if (game.service_key == "addition"){
    return (
      <> {gameStatus && topics ? (
        gameComponentAddition()
      ) : (
        
          <TopicsContainer lv={selectedLevel}>
            {selectedLevel != undefined ? (

              <Scale scaleTo={1920}>
                <div>
                  <GameSelectionContainer>
                    <h1>Select Topic to Learn</h1>
                          <Checkbox
                            label={"Number bonds of 5"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(2089);
                              } else {
                                onTopicsUnselect(2089);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 2089) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"Number bonds of 10"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(2090);
                              } else {
                                onTopicsUnselect(2090);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 2090) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"Number bonds of 20 (lower)"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(2091);
                              } else {
                                onTopicsUnselect(2091);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 2091) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"Number bonds of 20 (higher)"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(2092);
                              } else {
                                onTopicsUnselect(2092);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 2092) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"Doubling (0-5)"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(2093);
                              } else {
                                onTopicsUnselect(2093);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 2093) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"Doubling (5-10)"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(2094);
                              } else {
                                onTopicsUnselect(2094);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 2094) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"Adding 0"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(2129);
                              } else {
                                onTopicsUnselect(2129);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 2129) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"Adding 1"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(2108);
                              } else {
                                onTopicsUnselect(2108);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 2108) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"Adding 2"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(2109);
                              } else {
                                onTopicsUnselect(2109);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 2109) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"Adding 3"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(2110);
                              } else {
                                onTopicsUnselect(2110);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 2110) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"Adding 4"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(2111);
                              } else {
                                onTopicsUnselect(2111);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 2111) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"Adding 5"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(2112);
                              } else {
                                onTopicsUnselect(2112);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 2112) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"Adding 6"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(2113);
                              } else {
                                onTopicsUnselect(2113);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 2113) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"Adding 7"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(2114);
                              } else {
                                onTopicsUnselect(2114);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 2114) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"Adding 8"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(2115);
                              } else {
                                onTopicsUnselect(2115);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 2115) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"Adding 9"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(2116);
                              } else {
                                onTopicsUnselect(2116);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 2116) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"Adding 10"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(2117);
                              } else {
                                onTopicsUnselect(2117);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 2117) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"Subtracting 0"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(2118);
                              } else {
                                onTopicsUnselect(2118);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 2118) !== -1
                                ? true
                                : false
                            }
                          />
                           <Checkbox
                            label={"Subtracting 1"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(2119);
                              } else {
                                onTopicsUnselect(2119);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 2119) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"Subtracting 2"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(2120);
                              } else {
                                onTopicsUnselect(2120);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 2120) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"Subtracting 3"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(2121);
                              } else {
                                onTopicsUnselect(2121);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 2121) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"Subtracting 4"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(2122);
                              } else {
                                onTopicsUnselect(2122);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 2122) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"Subtracting 5"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(2123);
                              } else {
                                onTopicsUnselect(2123);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 2123) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"Subtracting 6"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(2124);
                              } else {
                                onTopicsUnselect(2124);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 2124) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"Subtracting 7"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(2125);
                              } else {
                                onTopicsUnselect(2125);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 2125) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"Subtracting 8"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(2126);
                              } else {
                                onTopicsUnselect(2126);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 2126) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"Subtracting 9"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(2127);
                              } else {
                                onTopicsUnselect(2127);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 2127) !== -1
                                ? true
                                : false
                            }
                          />
                          <Checkbox
                            label={"Subtracting 10"}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(2128);
                              } else {
                                onTopicsUnselect(2128);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === 2128) !== -1
                                ? true
                                : false
                            }
                          />

                  </GameSelectionContainer>
                  <div>
                    {selectedTopics.length > 0 ? (
                      <GreenButton
                        style={{ width: "20%" }}
                        onClick={() => launchGame()}
                      >
                        Play
                                </GreenButton>
                    ) : (
                        <GreyedButton data-tip="You need to add a topic to practice" style={{ width: "20%" }}>Play</GreyedButton>
                      )}

                  </div>

                </div>
              </Scale>
            ) : (
                <div>
                </div>
              )}
              
              <Buttonz onClick={() =>{navigate(".")}}>Back</Buttonz>
          </TopicsContainer>
        )}
    </>)
  }
}

const Buttonz = styled.button`
  background: rgb(234, 146, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 146, 19, 1) 0%,
    rgba(255, 186, 32, 1) 100%
  );
  width: 20%;
  border: 2px solid #e88f12;
  color: #fff;
  user-select: none;
  padding: 0.5em;
  margin: -0.5em 0;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`

const Tools = styled(ReactTooltip)`
  font-size: 20px !important;
  background-color: #543171FF !important;
  `

const LevelButton = styled(Button)`
    text-align: center;
    width: 10%;
    height: 70px;
    margin: 5px;
    color: #fff;
    user-select: none;
    background: ${props => (props.active ? "#673b8b," : "rgb(234, 146, 19)")};
    background: ${props =>
    props.active
      ? "linear-gradient(0deg, #673b8b, #683d8c)"
      : "linear-gradient(0deg,rgba(234, 146, 19, 1) 0%,rgba(255, 186, 32, 1) 100%)"};
    border: 2px solid ${props => (props.active ? "#673b8b" : "#e88f12")};

    padding: 0.5em;
    box-sizing: border-box;
    border-radius: 0.25em;
    font-size: 3em;
    cursor: ${props => (props.active ? "pointer" : "")};
    @media (min-width: 1025px) and (max-width: 1440px) {
        font-size: 2.5em;
    }

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
        margin-bottom: 0;
    }
`;
